module.exports = __webpack_public_path__ + "img/banner-domain.6a1e5866.png";